import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent race conditions under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace("#", ""));
      const sessionId = params.get("session_id");

      if (!sessionId) {
        console.error("No session_id found");
        navigate("/login", { replace: true });
        return;
      }

      try {
        const result = await exchangeSession(sessionId);
        
        // Redirect based on user role
        if (result.user?.role === "contractor" && result.user?.worker_id) {
          navigate("/dashboard", { replace: true, state: { user: result.user } });
        } else {
          navigate("/", { replace: true, state: { user: result.user } });
        }
      } catch (error) {
        console.error("Auth exchange failed:", error);
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [location, exchangeSession, navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#1a73e8] mx-auto mb-4" />
        <p className="text-[#5f6368]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
